var _rect, _rect2, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPurchasing = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  fill: "#EAF0FD",
  fillOpacity: 0.75,
  rx: 3.931
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 35,
  x: 0.5,
  y: 0.5,
  stroke: "#2F64ED",
  rx: 3.931
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M23.568 11.023 19.1 15.49l-4.469-4.468m4.469 4.469V6.092"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M28.246 12.185v8.307a2.215 2.215 0 0 1-2.216 2.216H12.738a2.215 2.215 0 0 1-2.215-2.216V14.4a2.215 2.215 0 0 0-2.216-2.215H5.538"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14.954,
  cy: 26.584,
  r: 2.215,
  stroke: "#2F64ED"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.815,
  cy: 26.584,
  r: 2.215,
  stroke: "#2F64ED"
})));
export { SvgPurchasing as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIzNSIgaGVpZ2h0PSIzNSIgcng9IjMuOTMwNzciIGZpbGw9IiNFQUYwRkQiIGZpbGwtb3BhY2l0eT0iMC43NSIvPgo8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjM1IiByeD0iMy45MzA3NyIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxwYXRoIGQ9Ik0yMy41Njg0IDExLjAyMjdMMTkuMDk5NyAxNS40OTE0TDE0LjYzMSAxMS4wMjI3IiBzdHJva2U9IiMyRjY0RUQiLz4KPHBhdGggZD0iTTE5LjA5OTMgMTUuNDkxMkwxOS4wOTkzIDYuMDkyMjciIHN0cm9rZT0iIzJGNjRFRCIvPgo8cGF0aCBkPSJNMjguMjQ1OCAxMi4xODQ2VjIwLjQ5MjNDMjguMjQ1OCAyMS43MTU4IDI3LjI1MzkgMjIuNzA3NiAyNi4wMzA0IDIyLjcwNzZIMTIuNzM4MUMxMS41MTQ2IDIyLjcwNzYgMTAuNTIyNyAyMS43MTU4IDEwLjUyMjcgMjAuNDkyM1YxNC40QzEwLjUyMjcgMTMuMTc2NCA5LjUzMDg0IDEyLjE4NDYgOC4zMDczMiAxMi4xODQ2SDcuNDc2NTVINS41MzgwOSIgc3Ryb2tlPSIjMkY2NEVEIi8+CjxlbGxpcHNlIGN4PSIxNC45NTM3IiBjeT0iMjYuNTg0NSIgcng9IjIuMjE1MzgiIHJ5PSIyLjIxNTM4IiBzdHJva2U9IiMyRjY0RUQiLz4KPGVsbGlwc2UgY3g9IjIzLjgxNSIgY3k9IjI2LjU4NDUiIHJ4PSIyLjIxNTM4IiByeT0iMi4yMTUzOCIgc3Ryb2tlPSIjMkY2NEVEIi8+Cjwvc3ZnPgo=";